module.exports = __webpack_public_path__ + "img/bg03.a085fa0e.png";